import {Box, makeStyles, Theme, Typography} from "@material-ui/core";
import React from "react";
interface IProps {
  label: string;
  input: React.ReactElement;
  width?: string;
}
const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontSize: "1.25rem",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      flexShrink: 1,
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    margin: "10px 10px 10px 0px",
    [theme.breakpoints.down("sm")]: {
      margin: "5px 5px 5px 0px",
    },
  },
}));
function FormItem(props: IProps) {
  const styles = useStyles();
  const {label, input, width} = props;
  return (
    <Box className={styles.container} width={`min(${width}, 100%)`}>
      <Typography
        variant="body1"
        style={{marginRight: "15px"}}
        className={styles.label}
      >
        {label}
      </Typography>
      {input}
    </Box>
  );
}

export default FormItem;
